(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cod-order-form"] && !Shopify.designMode) return;
  try {
    class CodOrderForm extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[ref="dialog"]');
      this.form = this.querySelector('[ref="form"]');
      this.trigger = this.querySelector('[ref="trigger"]');
      this.closeBtn = this.querySelector('[ref="close"]');
      this.submitBtn = this.querySelector('[ref="submit"]');
      this.spinner = this.querySelector('[ref="spinner"]');
      this.errorEl = this.querySelector('[ref="error"]');
      this.priceEl = this.querySelector('[ref="price"]');
      this.variantTitleEl = this.querySelector('[ref="variantTitle"]');
      this.thumbEl = this.querySelector('[ref="thumb"]');
      this.tiers = this.querySelector('[ref="tiers"]');
      this.applyBtn = this.querySelector('[ref="applyCode"]');
      this.discountInput = this.querySelector('[ref="discountInput"]');
      this.codeFeedback = this.querySelector('[ref="codeFeedback"]');
      this.rowSub = this.querySelector('[ref="rowSub"]');
      this.sumSub = this.querySelector('[ref="sumSub"]');
      this.rowBundle = this.querySelector('[ref="rowBundle"]');
      this.sumBundle = this.querySelector('[ref="sumBundle"]');
      this.rowCode = this.querySelector('[ref="rowCode"]');
      this.codeLabel = this.querySelector('[ref="codeLabel"]');
      this.sumCode = this.querySelector('[ref="sumCode"]');
      this.sumTotal = this.querySelector('[ref="sumTotal"]');

      this.webhook = this.dataset.webhook;
      this.calcUrl = this.dataset.calc;
      this.sectionId = this.dataset.sectionId;
      this.price1 = this.dataset.price1;
      this.price3 = this.dataset.price3;
      this.unitCents = parseInt(this.dataset.unitCents, 10) || 0;
      this.bundleCents = parseInt(this.dataset.bundleCents, 10) || 0;
      this.compareCents = parseInt(this.dataset.compareCents, 10) || 0;
      this.appliedCode = null;

      try {
        this.variants = JSON.parse(this.querySelector('[ref="variantData"]').textContent);
      } catch (e) { this.variants = []; }

      if (!this.dialog || !this.trigger) return;

      this.trigger.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      if (this.form) this.form.addEventListener('submit', (e) => this.handleSubmit(e));

      if (this.tiers) {
        this.tiers.addEventListener('change', () => this.onUnitsChange());
      }
      if (this.applyBtn) this.applyBtn.addEventListener('click', () => this.applyCode());
      if (this.discountInput) {
        this.discountInput.addEventListener('input', () => this.resetCode());
        this.discountInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); this.applyCode(); }
        });
      }
      this.setupValidation();
    }

    eur(cents) {
      return '€' + (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    onUnitsChange() {
      this.syncTier();
      this.resetCode();
    }

    resetCode() {
      this.appliedCode = null;
      if (this.codeFeedback) { this.codeFeedback.hidden = true; this.codeFeedback.textContent = ''; }
      this.renderBaseTotals();
    }

    /* total (cents) of the selected multi-tier option, or null if not a multi-tier picker */
    selectedTierTotal() {
      const checked = this.tiers ? this.tiers.querySelector('input[name="cod_units"]:checked') : null;
      if (checked && checked.dataset.totalCents != null && checked.dataset.totalCents !== '') {
        return parseInt(checked.dataset.totalCents, 10);
      }
      return null;
    }

    /* current line subtotal/bundle discount from local data (no server) */
    baseTotals() {
      const units = this.selectedUnits();
      const tierTotal = this.selectedTierTotal();
      if (tierTotal != null) {
        const sub = this.unitCents * units;
        return { sub: sub, bundle: Math.max(0, sub - tierTotal), total: tierTotal };
      }
      if (units === 3 && this.bundleCents > 0) {
        const sub = this.compareCents || (this.unitCents * 3);
        return { sub: sub, bundle: sub - this.bundleCents, total: this.bundleCents };
      }
      return { sub: this.unitCents, bundle: 0, total: this.unitCents };
    }

    renderBaseTotals() {
      const t = this.baseTotals();
      this.renderTotals({ sub: t.sub, bundle: t.bundle, code: 0, codeLabel: '', total: t.total });
    }

    renderTotals(o) {
      if (!this.sumTotal) return;
      const hasDiscount = (o.bundle > 0) || (o.code > 0);
      if (this.rowSub) { this.rowSub.hidden = !hasDiscount; if (this.sumSub) this.sumSub.textContent = this.eur(o.sub); }
      if (this.rowBundle) { this.rowBundle.hidden = !(o.bundle > 0); if (this.sumBundle) this.sumBundle.textContent = '−' + this.eur(o.bundle); }
      if (this.rowCode) {
        this.rowCode.hidden = !(o.code > 0);
        if (o.code > 0) {
          if (this.codeLabel) this.codeLabel.textContent = o.codeLabel || 'Codice sconto';
          if (this.sumCode) this.sumCode.textContent = '−' + this.eur(o.code);
        }
      }
      this.sumTotal.textContent = this.eur(o.total);
    }

    async applyCode() {
      if (!this.discountInput) return;
      const code = (this.discountInput.value || '').trim().toUpperCase();
      if (!code) { this.showCodeFeedback('Inserisci un codice.', false); return; }
      if (!this.calcUrl) { this.showCodeFeedback('Verifica non disponibile.', false); return; }
      this.applyBtn.disabled = true;
      const prevLabel = this.applyBtn.textContent;
      this.applyBtn.textContent = '…';
      try {
        const res = await fetch(this.calcUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant_id: this.currentVariantId(), quantity: this.selectedUnits(), discount_code: code })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data || !data.ok) {
          this.showCodeFeedback('Codice non valido. Riprova.', false);
          this.renderBaseTotals();
          return;
        }
        const c = (v) => Math.round(parseFloat(v) * 100);
        const codeCents = c(data.codeDiscount || 0);
        if (data.codeValid && codeCents > 1) {
          this.appliedCode = code;
          this.renderTotals({
            sub: c(data.subtotal),
            bundle: c(data.bundleDiscount || 0),
            code: codeCents,
            codeLabel: 'Codice ' + code,
            total: c(data.total)
          });
          this.showCodeFeedback('Codice applicato.', true);
        } else {
          this.appliedCode = null;
          this.renderBaseTotals();
          this.showCodeFeedback('Codice non valido o non applicabile a questo prodotto.', false);
        }
      } catch (e) {
        this.showCodeFeedback('Errore di connessione. Riprova.', false);
      } finally {
        this.applyBtn.disabled = false;
        this.applyBtn.textContent = prevLabel;
      }
    }

    showCodeFeedback(msg, ok) {
      if (!this.codeFeedback) return;
      this.codeFeedback.textContent = msg;
      this.codeFeedback.hidden = false;
      this.codeFeedback.classList.toggle('cod-order__discount-feedback--ok', ok);
      this.codeFeedback.classList.toggle('cod-order__discount-feedback--err', !ok);
    }

    selectedUnits() {
      const checked = this.tiers ? this.tiers.querySelector('input[name="cod_units"]:checked') : null;
      if (!checked) return 1;
      const u = parseInt(checked.value, 10) || 1;
      return u < 1 ? 1 : u;
    }

    syncTier() {
      if (!this.priceEl) return;
      const tierTotal = this.selectedTierTotal();
      if (tierTotal != null) { this.priceEl.textContent = this.eur(tierTotal); return; }
      const units = this.selectedUnits();
      if (units === 3 && this.price3) this.priceEl.textContent = this.price3;
      else if (this.price1) this.priceEl.textContent = this.price1;
    }

    currentVariantId() {
      const mainForm = document.getElementById('BuyButtons-ProductForm-' + this.sectionId);
      const idInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
      return (idInput && idInput.value) || this.dataset.defaultVariant;
    }

    syncProduct() {
      const id = String(this.currentVariantId());
      const v = this.variants.find((x) => String(x.id) === id);
      if (v) {
        if (!this.tiers) {
          this.price1 = v.price;
          if (this.priceEl) this.priceEl.textContent = v.price;
        }
        if (this.variantTitleEl && v.title && v.title !== 'Default Title') {
          this.variantTitleEl.textContent = v.title;
          this.variantTitleEl.hidden = false;
        }
        if (this.thumbEl && v.img) this.thumbEl.src = v.img;
      }
      this.syncTier();
    }

    open() {
      this.clearError();
      this.syncProduct();
      this.resetCode();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      this.errorEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    setLoading(on) {
      this.submitBtn.disabled = on;
      if (this.spinner) this.spinner.hidden = !on;
    }

    setupValidation() {
      if (!this.form) return;
      const fields = this.form.querySelectorAll('input, select');
      fields.forEach((el) => {
        el.addEventListener('invalid', () => el.setCustomValidity(this.messageFor(el)));
        el.addEventListener('input', () => el.setCustomValidity(''));
        el.addEventListener('change', () => el.setCustomValidity(''));
      });
    }

    messageFor(el) {
      const v = el.validity;
      if (v.valueMissing) return el.tagName === 'SELECT' ? 'Seleziona la provincia' : 'Questo campo è obbligatorio';
      if (v.typeMismatch && el.type === 'email') return 'Inserisci un’email valida';
      if (v.patternMismatch && el.name === 'phone') return 'Inserisci un numero di cellulare valido';
      if (v.patternMismatch && el.name === 'zip') return 'Il CAP deve avere 5 cifre';
      if (v.patternMismatch) return 'Controlla questo campo';
      return 'Controlla questo campo';
    }

    async handleSubmit(e) {
      e.preventDefault();
      this.clearError();

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      if (!this.webhook) {
        this.showError('Configurazione mancante. Riprova più tardi.');
        return;
      }

      const fd = new FormData(this.form);
      const payload = {
        variant_id: this.currentVariantId(),
        quantity: this.selectedUnits(),
        first_name: (fd.get('first_name') || '').trim(),
        last_name: (fd.get('last_name') || '').trim(),
        phone: (fd.get('phone') || '').trim(),
        email: (fd.get('email') || '').trim(),
        address1: (fd.get('address1') || '').trim(),
        zip: (fd.get('zip') || '').trim(),
        city: (fd.get('city') || '').trim(),
        province_code: fd.get('province_code') || '',
        discount_code: this.appliedCode || '',
        courier_note: (fd.get('courier_note') || '').trim(),
        cod_extra: fd.get('cod_extra') || ''
      };

      this.setLoading(true);
      try {
        const res = await fetch(this.webhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data && data.ok && data.statusUrl) {
          window.location.href = data.statusUrl;
          return;
        }
        this.showError((data && data.error) || 'Non siamo riusciti a completare l’ordine. Riprova.');
        this.setLoading(false);
      } catch (err) {
        this.showError('Errore di connessione. Controlla la rete e riprova.');
        this.setLoading(false);
      }
    }
  }

  if (!customElements.get('cod-order-form')) {
    customElements.define('cod-order-form', CodOrderForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-featured-videos"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-pfv-root]';

    function bind(root) {
      if (root.dataset.pfvBound === 'true') return;
      root.dataset.pfvBound = 'true';

      const dialog = root.querySelector('[data-pfv-dialog]');
      if (!dialog) return;

      const player = dialog.querySelector('[data-pfv-player]');
      const closeButtons = dialog.querySelectorAll('[data-pfv-close]');
      const triggers = root.querySelectorAll('[data-pfv-open]');
      const soundButton = dialog.querySelector('[data-pfv-sound]');
      const counter = dialog.querySelector('[data-pfv-counter]');
      const soundOnIcon = dialog.querySelector('[data-pfv-sound-on]');
      const soundOffIcon = dialog.querySelector('[data-pfv-sound-off]');
      const hint = dialog.querySelector('[data-pfv-hint]');
      let activeIndex = 0;
      let touchStartY = 0;
      let wheelLock = false;
      let hintTimer = null;
      const items = Array.from(triggers).map((trigger) => ({
        src: trigger.dataset.pfvSrc,
        type: trigger.dataset.pfvType,
        poster: trigger.dataset.pfvPoster || '',
      }));

      const updateUi = () => {
        if (counter) counter.textContent = `${activeIndex + 1} / ${items.length}`;
        if (soundButton && player) {
          const muted = !!player.muted;
          soundButton.setAttribute('aria-label', muted ? 'Attiva audio' : 'Disattiva audio');
          soundButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
          if (soundOnIcon) soundOnIcon.hidden = muted;
          if (soundOffIcon) soundOffIcon.hidden = !muted;
        }
      };

      const showHintOnce = () => {
        if (!hint) return;
        hint.dataset.pfvHintVisible = 'true';
        window.clearTimeout(hintTimer);
        hintTimer = window.setTimeout(() => {
        hint.dataset.pfvHintVisible = 'false';
        }, 3600);
      };

      const loadItem = async (index) => {
        const item = items[index];
        if (!item || !player || !item.src) return;
        activeIndex = index;
        player.pause();
        player.removeAttribute('src');
        player.innerHTML = '';
        const source = document.createElement('source');
        source.src = item.src;
        if (item.type) source.type = item.type;
        player.appendChild(source);
        if (item.poster) player.poster = item.poster;
        else player.removeAttribute('poster');
        player.load();
        player.currentTime = 0;
        player.muted = false;
        player.defaultMuted = false;
        player.removeAttribute('muted');
        player.volume = 1;
        try { await player.play(); } catch (_error) {}
        updateUi();
      };

      const goTo = (index) => {
        if (index < 0 || index >= items.length || index === activeIndex) return;
        loadItem(index);
      };

      const stepBy = (direction) => {
        goTo(activeIndex + direction);
      };

      for (const trigger of triggers) {
        trigger.addEventListener('click', async () => {
          if (!trigger.dataset.pfvSrc) return;
          const index = Number(trigger.dataset.pfvIndex) || 0;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          await loadItem(index);
          showHintOnce();
        });
      }

      soundButton?.addEventListener('click', async () => {
        if (!player) return;
        player.muted = !player.muted;
        if (!player.muted) {
          player.defaultMuted = false;
          player.removeAttribute('muted');
          player.volume = 1;
          try { await player.play(); } catch (_error) {}
        }
        updateUi();
      });

      dialog.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) < 12) return;
        event.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        stepBy(event.deltaY > 0 ? 1 : -1);
        window.setTimeout(() => {
          wheelLock = false;
        }, 220);
      }, { passive: false });

      dialog.addEventListener('touchstart', (event) => {
        touchStartY = event.touches[0]?.clientY || 0;
      }, { passive: true });

      dialog.addEventListener('touchend', (event) => {
        const touchEndY = event.changedTouches[0]?.clientY || 0;
        const deltaY = touchStartY - touchEndY;
        if (Math.abs(deltaY) < 40) return;
        stepBy(deltaY > 0 ? 1 : -1);
      }, { passive: true });

      const handleClose = () => {
        if (player) {
          player.pause();
          player.currentTime = 0;
          player.removeAttribute('src');
          player.innerHTML = '';
        }
        activeIndex = 0;
        wheelLock = false;
        window.clearTimeout(hintTimer);
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        if (typeof dialog.close === 'function') dialog.close();
      };

      for (const btn of closeButtons) btn.addEventListener('click', handleClose);

      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        handleClose();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) handleClose();
      });

    }

    const init = () => {
      for (const root of document.querySelectorAll(ROOT_SELECTOR)) bind(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const el = event.target;
      if (!el) return;
      const root = el.querySelector ? el.querySelector(ROOT_SELECTOR) : null;
      if (root) bind(root);
      else if (el.matches && el.matches(ROOT_SELECTOR)) bind(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-rich-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '.product-rich-accordion';

    function bind(root) {
      if (root.dataset.praBound === 'true') return;
      root.dataset.praBound = 'true';

      const dialog = root.querySelector('[data-pra-dialog]');
      const player = root.querySelector('[data-pra-player]');
      if (!dialog || !player) return;

      const close = () => {
        player.pause();
        player.removeAttribute('src');
        player.innerHTML = '';
        if (typeof dialog.close === 'function') dialog.close();
      };

      root.querySelectorAll('[data-pra-open]').forEach((trigger) => {
        trigger.addEventListener('click', async () => {
          if (!trigger.dataset.praSrc) return;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');

          player.pause();
          player.removeAttribute('src');
          player.innerHTML = '';
          const source = document.createElement('source');
          source.src = trigger.dataset.praSrc;
          if (trigger.dataset.praType) source.type = trigger.dataset.praType;
          player.appendChild(source);
          if (trigger.dataset.praPoster) player.poster = trigger.dataset.praPoster;
          else player.removeAttribute('poster');
          player.load();
          player.currentTime = 0;
          player.muted = false;
          player.defaultMuted = false;
          player.removeAttribute('muted');
          player.volume = 1;
          try { await player.play(); } catch (_error) {}
        });
      });

      root.querySelector('[data-pra-close]')?.addEventListener('click', close);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
    }

    const init = () => document.querySelectorAll(ROOT_SELECTOR).forEach(bind);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-whatsapp-consult"] && !Shopify.designMode) return;
  try {
    class WhatsAppConsult extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[ref="link"]') || this.querySelector('a');
      if (!this.link) return;
      this.updateHref();
      // Re-check the recipient at tap time so an open page never routes to the wrong number.
      this.link.addEventListener('pointerdown', () => this.updateHref());
      this.link.addEventListener('focus', () => this.updateHref());
    }

    romeNow() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Rome',
          weekday: 'short',
          hour: 'numeric',
          hourCycle: 'h23',
        }).formatToParts(new Date());
        const hourPart = parts.find((p) => p.type === 'hour');
        const weekdayPart = parts.find((p) => p.type === 'weekday');
        const now = new Date();
        return {
          hour: hourPart ? parseInt(hourPart.value, 10) : now.getHours(),
          weekday: weekdayPart ? weekdayPart.value : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][now.getDay()],
        };
      } catch (e) {
        const now = new Date();
        return { hour: now.getHours(), weekday: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][now.getDay()] };
      }
    }

    updateHref() {
      const open = parseInt(this.dataset.openHour, 10);
      const close = parseInt(this.dataset.closeHour, 10);
      const { hour, weekday } = this.romeNow();
      const isWeekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday);
      const isBusinessHours = isWeekday && hour >= open && hour < close;
      const phone = isBusinessHours
        ? this.dataset.phoneBusiness
        : this.dataset.phoneAfterHours || this.dataset.phoneBusiness;
      const message = this.dataset.message || '';
      this.link.href = `https://wa.me/${phone}?text=${message}`;
    }
  }

  if (!customElements.get('whatsapp-consult')) {
    customElements.define('whatsapp-consult', WhatsAppConsult);
  }
  } catch(e) { console.error(e); }
})();

})();
